import { AfterViewInit, Component, ElementRef, HostListener, Input, SimpleChanges, ViewChild } from '@angular/core';
import * as pdfjs from 'pdfjs-dist';
import { PDFDocumentProxy, PDFPageProxy } from 'pdfjs-dist/types/src/display/api';
// pdfjs-dist/build/pdf

pdfjs.GlobalWorkerOptions.workerSrc = 'assets/pdf.worker.min.js';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.css',
  standalone: false,
})
export class PdfViewerComponent implements AfterViewInit {
  @ViewChild('pdfCanvas') pdfCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() URL: string | null | undefined = "";
  @Input() Blob: Blob | null | undefined = null;
  @Input() pageNumber: number = 1;
  pdfDoc: PDFDocumentProxy | null = null;
  page: PDFPageProxy | null = null;


  ngAfterViewInit(): void {
    this.loadPdf(this.pageNumber);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageNumber']) {
      this.loadPdf(this.pageNumber);

    }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.renderPage();
  }

  async loadPdf(page: number) {
    try {
      if (this.Blob) {
        await this.Blob.arrayBuffer().then(async (arrayBuffer) => {
          this.pdfDoc = await pdfjs.getDocument(arrayBuffer).promise;
          this.page = await this.pdfDoc.getPage(page);
        this.renderPage();
        });
      } else {
        this.pdfDoc = await pdfjs.getDocument(this.URL ?? "").promise;
        this.page = await this.pdfDoc.getPage(page);
        this.renderPage();
      }
    } catch (error) {
      console.error('Error loading PDF', error);
    }
  }

  changePageNumber (direction: number) {

  }

  renderPage() {
    if (!this.page || !this.pdfCanvas) return;

    const canvas = this.pdfCanvas.nativeElement as HTMLCanvasElement;
    const context = canvas.getContext('2d');
    if (!context) return;
    let viewport = this.page.getViewport({ scale: 1, dontFlip: false });

    var viewHeight = window.innerHeight;
    var viewWidth = window.innerWidth;
    const pdfWidth = viewport.width;
    const pdfHeight = viewport.height;

    if (viewWidth < pdfWidth){
      const scale = Math.min(viewWidth / pdfWidth) - .25;
      viewport = this.page.getViewport({ scale: scale, dontFlip: false });
    }

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvas: canvas,
      canvasContext: context,
      viewport: viewport,
    };

    this.page.render(renderContext);
  }
}
